<template>
  <div class="filter-container-left mb-6 w-2/5">
    <label for="broker-select" class="block text-gray-700">
      Selecione uma Corretora:
    </label>
    <v-select
      v-model="selectedCorretora"
      :options="corretoras"
      label="label"
      :reduce="(corretora) => corretora.id"
      @input="handleCorretoraChange"
      placeholder="Escolha a corretora"
      class="block mt-2"
    ></v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import autoApi from '../../services/auto.api';
import jwt from 'jsonwebtoken';
import { REPORT_ALL_BROKERS } from '../../utils/constants';

export default {
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      corretoras: [],
      selectedCorretora: null,
      currentUser: null,
    };
  },
  async mounted() {
    this.getDecoded();

    if (this.$can('Leitura Carteira Completa', 'Dashboard')) {
      await this.getBrokersList();
      return;
    }

    if (
      this.$can('Leitura Carteira Assessoria', 'Dashboard') &&
      this.currentUser &&
      this.currentUser.id_divisao
    ) {
      await this.getBrokersByUser();
      return;
    }

    if (
      this.$can('Leitura Carteira Convênio', 'Dashboard') &&
      this.currentUser &&
      this.currentUser.id_convenio
    ) {
      await this.getBrokersByUser();
      return;
    }

    return (this.corretoras = []);
  },
  methods: {
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.currentUser = jwt.decode(token);
      }
    },
    handleCorretoraChange() {
      this.$emit('brokerSelected', this.selectedCorretora);
    },
    setBrokersList(brokers) {
      this.corretoras = brokers;
      this.corretoras.sort((a, b) => a.label.localeCompare(b.label));

      if (this.corretoras.length <= 1) return;

      this.corretoras.unshift({
        label: REPORT_ALL_BROKERS.LABEL,
        id: REPORT_ALL_BROKERS.ID,
      });
    },
    openErrorAlert() {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'Erro ao buscar as corretoras',
        color: 'danger',
      });
    },
    getBrokersList() {
      autoApi
        .getBrokersList()
        .then((res) => {
          this.setBrokersList(res);
        })
        .catch(() => {
          this.openErrorAlert();
        });
    },
    getBrokersByUser() {
      autoApi
        .getBrokersByUser()
        .then((res) => {
          this.setBrokersList(res);
        })
        .catch(() => {
          this.openErrorAlert();
        });
    },
  },
};
</script>
